import getNotificationBarHostId from '../selectors/getNotificationBarHostId';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { retryButtonText } from 'owa-locstrings/lib/strings/retrybuttontext.locstring.json';
import {
    DefaultHotKeyCommand,
    DefaultNotificationBarCallbackReason,
    lazyShowNotificationWithButtonCallback,
    lazyShowNotification,
} from 'owa-notification-bar-force-dismiss';

export default function showRetryNotification(
    actionName: string,
    messageString: string,
    callback: (() => void) | ((retry: boolean) => void)
) {
    const notificationBarHostId = getNotificationBarHostId();
    const primaryActionText = loc(retryButtonText);
    const icon = ControlIcons.Error;
    const primaryActionHotKeyCommand = DefaultHotKeyCommand.Retry;

    if (callback.length == 0) {
        lazyShowNotificationWithButtonCallback.importAndExecute(
            actionName,
            notificationBarHostId,
            messageString,
            primaryActionText,
            callback as () => void,
            icon,
            primaryActionHotKeyCommand
        );
    } else {
        lazyShowNotification.importAndExecute(
            actionName,
            notificationBarHostId,
            messageString,
            { icon, primaryActionHotKeyCommand },
            {
                primaryActionText,
                notificationCallback: reason => {
                    callback(reason === DefaultNotificationBarCallbackReason.PrimaryActionClicked);
                },
            }
        );
    }
}
